import { AssetManifest, CONSTANTS } from '../types';

export function loadImage(path: string): Promise<HTMLImageElement> {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve(img);
    img.onerror = () => reject(new Error(`Failed to load image: ${path}`));
    img.src = path;
  });
}

export function applyMagentaTransparency(img: HTMLImageElement): HTMLCanvasElement {
  const canvas = document.createElement('canvas');
  canvas.width = img.width;
  canvas.height = img.height;

  const ctx = canvas.getContext('2d');
  if (!ctx) {
    throw new Error('Failed to get 2D context');
  }

  ctx.drawImage(img, 0, 0);

  const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
  const data = imageData.data;

  for (let i = 0; i < data.length; i += 4) {
    const r = data[i];
    const g = data[i + 1];
    const b = data[i + 2];

    // Check for magenta (255, 0, 255)
    if (r === 255 && g === 0 && b === 255) {
      data[i + 3] = 0; // Set alpha to 0
    }
  }

  ctx.putImageData(imageData, 0, 0);
  return canvas;
}

async function loadIndexedImages(
  basePath: string,
  count: number,
  applyTransparency: boolean
): Promise<HTMLCanvasElement[]> {
  const promises: Promise<HTMLCanvasElement>[] = [];

  for (let i = 0; i < count; i++) {
    promises.push(
      loadImage(`${basePath}/${i}.png`).then((img) =>
        applyTransparency ? applyMagentaTransparency(img) : imageToCanvas(img)
      )
    );
  }

  return Promise.all(promises);
}

function imageToCanvas(img: HTMLImageElement): HTMLCanvasElement {
  const canvas = document.createElement('canvas');
  canvas.width = img.width;
  canvas.height = img.height;
  const ctx = canvas.getContext('2d');
  if (!ctx) {
    throw new Error('Failed to get 2D context');
  }
  ctx.drawImage(img, 0, 0);
  return canvas;
}

export async function loadAllAssets(): Promise<AssetManifest> {
  console.log('Loading assets...');

  const [
    gladiators,
    battleArrows,
    hitMarkers,
    titleScreen,
    battleSetupArrowImg,
    shootIconImg,
    map0Image,
    map0Clip,
  ] = await Promise.all([
    loadIndexedImages('/gladiators', CONSTANTS.GLADIATOR_COUNT, true),
    loadIndexedImages('/battle', CONSTANTS.BATTLE_ARROW_COUNT, true),
    loadIndexedImages('/hit', CONSTANTS.HIT_MARKER_COUNT, true),
    loadImage('/titlescreen background.png'),
    loadImage('/battle setup arrow.png'),
    loadImage('/shoot.png'),
    loadImage('/maps/0 image.png'),
    loadImage('/maps/0 clip.png'),
  ]);

  const battleSetupArrow = applyMagentaTransparency(battleSetupArrowImg);
  const shootIcon = applyMagentaTransparency(shootIconImg);

  console.log(`Loaded ${gladiators.length} gladiator portraits`);
  console.log(`Loaded ${battleArrows.length} battle arrows`);
  console.log(`Loaded ${hitMarkers.length} hit markers`);
  console.log('All assets loaded successfully');

  return {
    gladiators,
    maps: [{ image: map0Image, clip: map0Clip }],
    battleArrows,
    hitMarkers,
    titleScreen,
    battleSetupArrow,
    shootIcon,
  };
}
